<div class="coverage-item card mb-2">
    <div class="card-body py-2 px-3">
        <!-- Header with name and remove button -->
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
                <span class="fw-semibold">{{ coverageName }}</span>
                <small class="text-muted ms-2">({{ coverageCode }})</small>
            </div>
            <button type="button" class="btn btn-sm btn-link text-danger p-0" (click)="onRemove()" [disabled]="disabled"
                title="Eliminar cobertura">
                <span class="material-symbols-outlined" style="font-size: 20px;">delete</span>
            </button>
        </div>

        <!-- Required checkbox -->
        <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="required-{{ coverageCode }}"
                [checked]="coverage.isRequired" (change)="onPrimaryChange($any($event.target).checked)"
                [disabled]="disabled">
            <label class="form-check-label" for="required-{{ coverageCode }}">
                Es Cobertura Requerida
            </label>
        </div>

        <!-- Calculated checkbox -->
        <div class="form-check mb-2">
            <input class="form-check-input" type="checkbox" id="calculated-{{ coverageCode }}"
                [(ngModel)]="coverage.isCalculated" (ngModelChange)="emitChange()" [disabled]="disabled">
            <label class="form-check-label" for="calculated-{{ coverageCode }}">
                Límite Calculado (Prima Neta × Plazo)
            </label>
        </div>

        <!-- Calculated info alert -->
        <div *ngIf="coverage.isCalculated" class="alert alert-info small py-2 mb-2">
            <span class="material-symbols-outlined align-middle" style="font-size: 16px;">info</span>
            El monto asegurado será calculado automáticamente: Prima Neta Anual × Duración
        </div>

        <!-- Tariff Selector (Dynamic) -->
        <div *ngIf="showTariffSelector" class="mb-2">
            <label class="form-label small fw-medium mb-1">Tipo de Tarifa</label>
            <ng-select [items]="tariffOptions" bindLabel="label" bindValue="value" [(ngModel)]="coverage.tariffType"
                (change)="emitChange()" [clearable]="false" [searchable]="false" [disabled]="disabled"
                placeholder="Seleccione tarifa...">
            </ng-select>
        </div>

        <!-- Max Age -->
        <div class="row align-items-center mb-2">
            <label class="col-auto col-form-label ml-4 small">Edad Máx. Entrada:</label>
            <div class="col-auto">
                <div class="input-group input-group-sm" style="width: 120px;">
                    <input type="text" class="form-control" [(ngModel)]="coverage.maxAge" (blur)="emitChange()"
                        mask="0*" [disabled]="disabled || coverage.isRequired">
                </div>
            </div>

            <label class="col-auto col-form-label ml-4 small">Edad Máx. Duración:</label>
            <div class="col-auto">
                <div class="input-group input-group-sm" style="width: 120px;">
                    <input type="text" class="form-control" [(ngModel)]="coverage.maxDurationAge" (blur)="emitChange()"
                        mask="0*" [disabled]="disabled || coverage.isRequired">
                </div>
            </div>
        </div>

        <!-- % of the sum assured (also for required coverages, e.g. Desmembramiento = 100% of Muerte) -->
        <div class="ms-4 mb-2">
            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="customFraction-{{ coverageCode }}"
                    [checked]="useCustomFraction" (change)="onUseCustomFractionChange($any($event.target).checked)"
                    [disabled]="disabled">
                <label class="form-check-label" for="customFraction-{{ coverageCode }}">
                    Personalizar % de suma asegurada
                </label>
                <div class="form-text mt-0">El monto se calcula sobre la cobertura principal y el cliente no puede
                    cambiarlo (100% = igual a la principal).</div>
            </div>

            <!-- Fraction input (only if custom fraction is enabled) -->
            <div *ngIf="useCustomFraction" class="row align-items-center mb-2">
                <label class="col-auto col-form-label small">% de suma asegurada:</label>
                <div class="col-auto">
                    <div class="input-group input-group-sm" style="width: 120px;">
                        <input type="text" class="form-control" [(ngModel)]="coverage.insurePrimaryFraction"
                            (blur)="emitChange()" mask="percent" suffix="%" [dropSpecialCharacters]="true"
                            [disabled]="disabled">
                    </div>
                </div>
            </div>
        </div>

        <!-- Currency selection (only for non-calculated coverages) -->
        <div class="mt-3 pt-2 border-top"
            *ngIf="availableCurrencies.length > 0 && !coverage.isCalculated && !useCustomFraction">
            <label class="form-label small fw-medium mb-2">Límites por Moneda:</label>
            <div class="currency-list">
                <div *ngFor="let currency of availableCurrencies" class="mb-3 border-bottom pb-2">
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                        <span class="fw-medium small">{{ currency.currency }}</span>
                        <div class="form-check form-switch m-0 pb-0">
                            <input class="form-check-input" type="checkbox"
                                [id]="'fixed-limit-' + coverageCode + '-' + currency.id"
                                [ngModel]="coverage.currencies[getCurrencyIndex(currency.id)]?.isFixedLimit"
                                (ngModelChange)="onFixedLimitChange(currency.id, $event)" [disabled]="disabled">
                            <label class="form-check-label small text-muted"
                                [for]="'fixed-limit-' + coverageCode + '-' + currency.id">¿Límite Fijo?</label>
                        </div>
                    </div>

                    <div *ngIf="!coverage.currencies[getCurrencyIndex(currency.id)].isFixedLimit" class="d-flex gap-2">
                        <div class="input-group input-group-sm">
                            <span class="input-group-text">Mínimo</span>
                            <input type="text" class="form-control"
                                [ngModel]="coverage.currencies[getCurrencyIndex(currency.id)]?.minAmount"
                                (ngModelChange)="updateCurrencyMinAmount(currency.id, $event)" (blur)="emitChange()"
                                mask="separator.2" thousandSeparator="," [disabled]="disabled || coverage.isRequired"
                                placeholder="0.00">
                        </div>
                        <div class="input-group input-group-sm">
                            <span class="input-group-text">Máximo</span>
                            <input type="text" class="form-control"
                                [ngModel]="coverage.currencies[getCurrencyIndex(currency.id)]?.maxAmount"
                                (ngModelChange)="updateCurrencyMaxAmount(currency.id, $event)" (blur)="emitChange()"
                                mask="separator.2" thousandSeparator="," [disabled]="disabled || coverage.isRequired"
                                placeholder="0.00">
                        </div>
                    </div>

                    <div *ngIf="coverage.currencies[getCurrencyIndex(currency.id)].isFixedLimit" class="d-flex gap-2">
                        <div class="input-group input-group-sm w-50">
                            <span class="input-group-text">Límite</span>
                            <input type="text" class="form-control"
                                [ngModel]="coverage.currencies[getCurrencyIndex(currency.id)]?.minAmount"
                                (ngModelChange)="updateCurrencyMinAmount(currency.id, $event)" (blur)="emitChange()"
                                mask="separator.2" thousandSeparator="," [disabled]="disabled" placeholder="0.00">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Minimum premium per currency (applies to calculated and non-calculated coverages) -->
        <div class="mt-3 pt-2 border-top" *ngIf="availableCurrencies.length > 0">
            <label class="form-label small fw-medium mb-2">Prima mínima por moneda (sin impuestos):</label>
            <div class="d-flex flex-wrap gap-2">
                <div *ngFor="let currency of availableCurrencies" class="input-group input-group-sm"
                    style="max-width: 220px">
                    <span class="input-group-text">{{ currency.currency }}</span>
                    <input type="text" class="form-control"
                        [ngModel]="coverage.currencies[getCurrencyIndex(currency.id)]?.minPremium"
                        (ngModelChange)="updateCurrencyMinPremium(currency.id, $event)"
                        mask="separator.2" thousandSeparator="," [disabled]="disabled"
                        placeholder="Sin mínimo">
                </div>
            </div>
        </div>

        <div *ngIf="availableCurrencies.length === 0" class="text-muted small fst-italic mt-2">
            Primero configure los límites del producto.
        </div>

        <!-- Rate Selector (Dynamic for Personal Accidents) -->
        <div *ngIf="showRateSelector" class="mt-3">
            <app-coverage-rate-selector [categories]="coverage.categories" [maxAge]="coverage.maxAge || 100"
                (categoriesChange)="emitChange()">
            </app-coverage-rate-selector>
        </div>
    </div>
</div>